import { Component } from '@headless-workspace/typings';

const SWOGO_ID = 'swogo-bundle-1';
const SWOGO_CLASSNAME = 'swogo-box';

export const CrossSellsBundlesContainer: Component = () => <div id={SWOGO_ID} className={SWOGO_CLASSNAME}></div>;
